module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.onScroll),
      expression: "onScroll"
    }],
    attrs: {
      "light": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "z-index": "2",
      "position": "absolute",
      "width": "100vw",
      "height": "100vh"
    },
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('h2', {
    staticClass: "white--text"
  }, [_vm._v("J. Hermosilla")]), _vm._v(" "), _c('h4', {
    staticClass: "white--text bold--text pa-2",
    staticStyle: {
      "background": "rgba(0,0,0,0.5)"
    }
  }, [_vm._v("GIS & Web Mapping!")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100vw",
      "height": "100vh"
    },
    attrs: {
      "id": "banner-welcome"
    }
  }, [_c('v-parallax', {
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "jumbotron": "",
      "src": "/static/img/paisaje.jpg"
    }
  })], 1), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "color": "grey lighten-5 primary",
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-scale-transition', [_c('v-card', {
    staticClass: "card--flex-toolbar"
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "color": "white",
      "prominent": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "body-2 grey--text"
  }, [_c('v-avatar', {
    staticClass: "grey lighten-4",
    attrs: {
      "size": "48px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/joseahr.jpg",
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Jose Ángel Hermosilla Rodrigo")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('h5', {
    staticClass: "primary--text"
  }, [_vm._v("¡Bienvenido!")]), _vm._v(" "), _c('p', [_vm._v("Me llamo Jose Ángel y soy Ingeniero en Geomática y Topografía.")]), _vm._v(" "), _c('p', [_vm._v("Gracias a mi formación soy experto en diversas materias como: Geodesia, SIG, IDEs, Web Mapping...")]), _vm._v(" "), _c('p', [_vm._v("Me apasiona la programación y aprendo cada día de las nuevas tecnologías.")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://github.com/joseahr",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://stackoverflow.com/users/3866134/jose-hermosilla-rodrigo?tab=profile",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-stack-overflow fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.facebook.com/jose.hermosillarodrigo",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.instagram.com/josehermosillarodrigo/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.linkedin.com/in/jose-%C3%A1ngel-hermosilla-rodrigo-70a590147/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x"
  })])], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "primary": "",
      "to": "/index/profile"
    }
  }, [_vm._v("Saber Más")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "primary": "",
      "to": "/index/portfolio"
    }
  }, [_vm._v("Trabajos")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-footer', [_c('div', [_vm._v("© " + _vm._s(new Date().getFullYear()))])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b2b8480","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Main.vue
// module id = 264
// module chunks = 1